import { render } from "./BannerNotification.vue?vue&type=template&id=3da0cca6"
import script from "./BannerNotification.vue?vue&type=script&lang=js"
export * from "./BannerNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__